module.exports = __webpack_public_path__ + "static2023-4-17/img/精华评论.9240e45c.png";